export const GROUP_SUBSCRIBED_FEED_MENU_MORE = 'group-subscribed-feed-more';
export const GROUP_SUBSCRIBED_FEED_MENU_ORDERBY = 'group-subscribed-feed-orderby';

export const emptyComplaintsCounts = {};
